import when from 'ally.js/esm/when/_when';
import debounce from 'lodash/debounce';
import {checkVerticalresize, getHeight} from '../base/utils';
import FocusHandler from './focus-handler';
import Popup from './popup';

class Modal {
    constructor($link, hash, options) {
        let [id, anchor, ..._] = hash.split(',');
        this.id = id;
        this.anchor = anchor;
        this.$link = $link;
        this.$dialog = document.getElementById(id);
        this.options = options || {};

        if (!this.$link || !this.$dialog) {
            return;
        }

        this.$inner = this.$dialog.querySelector('.modal-inner');
        this.$contents = this.$dialog.querySelector('.modal-popup');
        this.$titleWrap = this.$dialog.querySelector('.modal-title');
        this.$title = this.$titleWrap.querySelector('.modal-title-inner');

        this.init();
    }

    init() {
        this.$link.setAttribute('title', `Otwórz warstwę`);
        this.$link.setAttribute('aria-controls', `${this.id}`);
        this.$link.setAttribute('aria-expanded', 'false');

        this.events();

        this.escHandler = null;
    }

    events() {
        this.$link.addEventListener('click', e => {
            e.preventDefault();

            this.showDialog();
        });

        [...this.$dialog.querySelectorAll('.popup-close')].forEach($el => {
            $el.addEventListener('mousedown', e => {
                this.hideDialog(e.target);
            })
        });

        this.$dialog.querySelector('.popup-close').addEventListener('keypress', e => {
            this.hideDialog(e.target);
            setTimeout(() => this.$link.focus(), 200);
        });

        when.key({
            enter: (e, disengage) => {
                if (e.target !== this.$link)
                    return;

                this.showDialog();
                setTimeout(() => this.$dialog.focus(), 200);

                disengage();
            },
        });

        this.$dialog.addEventListener('click', this.handleOverlayClick.bind(this));
        window.addEventListener('resize', debounce(this.handleResize.bind(this), 100));
        window.addEventListener('load', this.handleResize.bind(this));
        this.$inner.addEventListener('scroll', debounce(this.fixTitle.bind(this), 50, {trailing: true}));
    }

    handleResize() {
        checkVerticalresize(this.windowWidth, () => {
            this.windowWidth = window.innerWidth;

            let titleHeight,
                titleWrapHeight;

            titleWrapHeight = getHeight(this.$titleWrap, 'full', 200, () => {
                this.$title.style.maxHeight = 'none';
                titleHeight = this.$title.offsetHeight;
            });

            this.$title.style.maxHeight = titleHeight + 'px';
            this.$contents.style.paddingTop = titleWrapHeight + 'px';
        });
    }

    fixTitle() {
        let top = this.$inner.scrollTop === 0;

        if (top) {
            clearTimeout(this.timeout);
            this.$titleWrap.classList.add('on-top');
            this.$titleWrap.classList.remove('not-on-top');
            this.$titleWrap.classList.remove('nowrap');
        } else {
            clearTimeout(this.timeout);
            this.$titleWrap.classList.add('not-on-top');
            this.$titleWrap.classList.remove('on-top');
            this.timeout = setTimeout(() => {
                this.$titleWrap.classList.add('nowrap');
            }, 400);
        }
    }

    showDialog() {
        if (typeof this.options.onOpen === 'function') {
            this.options.onOpen();
        }

        Popup.open(this.$dialog);
        this.$link.setAttribute('aria-expanded', 'true');

        if (this.anchor) {
            setTimeout(() => {
                FocusHandler.focus(document.getElementById(this.anchor));
            }, 200);
        }

        this.escHandler = when.key({
            escape: (e, disengage) => {
                this.hideDialog();
                this.$link.focus();

                disengage();
            },
        });
    }

    hideDialog($trigger) {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose($trigger);
        }

        Popup.close(this.$dialog);
        this.$link.setAttribute('aria-expanded', 'false');

        setTimeout(() => {
            this.$inner.scroll({top: 0, left: 0});
        }, 200);
    }

    handleOverlayClick(e) {
        if (!e.target.closest('.modal-popup') && !e.target.closest('.container__main')) { // litepicker
            this.hideDialog();
        }
    }
}

export default Modal;
